import request from '@/utils/request'

export function getPageImages(pageName) {
  return request.get('/api/page-images', {
    params: { pageName }
  })
}

/** 页面级：code → url */
export function getPageImageMap(pageName) {
  return request.get('/api/page-images/map', {
    params: { pageName }
  })
}

/** 模块级图库：按 moduleId 拉取 */
export function getProductGalleryByModuleId(pageName, moduleId) {
  return request.get('/api/page-images/gallery', {
    params: { pageName, moduleId }
  })
}
